// import { urlSafeDecode } from '@aws-amplify/core'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import Link from '../link'
import Tail from '../tail'

const ProgramCard = ({
  program: { id, cover, title, intro },
  tailDirection,
}) => {
  return (
    <Link key={id} href={`/program/${id}`} noUnderline>
      <div className='p-custom-card group relative mx-auto mb-[30px] flex max-w-[593px] flex-col rounded-4xl'>
        <Tail
          className={classNames(
            tailDirection === 'right'
              ? 'pointer-events-none absolute right-0 bottom-0 -z-0 h-5 translate-x-[40%] translate-y-[10%]'
              : 'pointer-events-none absolute left-0 bottom-0 -z-0 h-5 -translate-x-[40%] translate-y-[10%] scale-x-[-1]',
          )}
          fill='white'
        />
        <h3 className='custom-font-37 mb-4 font-bold uppercase text-theme-blue-gray'>
          {title}
        </h3>
        <div
          className='card-bg-img flex space-x-4'
          style={{ backgroundImage: `url(${cover.image})` }}
        >
          <div className='flex flex-1 flex-col space-y-2'>
            <p className='custom-font-30 mb-4'>{intro}</p>
            <div className='flex w-fit flex-1 flex-col justify-end '>
              <p className='custom-font-30 pb-0·pt-[5px] translate-y-0.5 border border-dotted border-theme-blue-gray/40 px-[5px] pt-1.5 font-bold'>
                REGISTER
              </p>
            </div>
          </div>
          <div className='flex aspect-[2/3] w-2/5' />
        </div>
      </div>
    </Link>
  )
}

export default ProgramCard

ProgramCard.propTypes = {
  program: PropTypes.shape({
    cover: PropTypes.shape({
      image: PropTypes.string.isRequired,
      video: PropTypes.string.isRequired,
    }),
    handle: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    intro: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  tailDirection: PropTypes.oneOf(['left', 'right']).isRequired,
}
